import axios from "../api/axiosInstance";
import { persistAuthSession, readStoredAuthToken } from "./sessionUser";
import { filterWorkspaceBusinessUnits, hasBusinessUnitWorkspaceAccess, resolveLoginWorkspacePath, workspaceAccessKey } from "./workspaceAccess";
export async function completeLogin(data, navigate, signal) {
  const controller = { signal: signal || { aborted: false } };
  const user = persistAuthSession(data);
  const target = resolveLoginWorkspacePath(user);
  let workspaceBootstrap;
  if (target === "/select-workspace" && hasBusinessUnitWorkspaceAccess(user)) {
    // Keep the existing login visible until the next screen can paint its
    // cards at once, instead of flashing a short, recentered loading screen.
    workspaceBootstrap = { accessKey: workspaceAccessKey(user), businessUnits: [], failed: false };
    try {
      const { data: units } = await axios.get("/api/business-units", {
        timeout: 15_000, ...(signal ? { signal } : {}),
      });
      if (!Array.isArray(units)) throw new Error("Invalid business unit response");
      workspaceBootstrap.businessUnits = filterWorkspaceBusinessUnits(units, user);
    } catch (_error) {
      // Authentication succeeded: show a retryable workspace error, not a
      // second login. Admin and Corporate remain independently accessible.
      workspaceBootstrap.failed = true;
    }
  }
  if (controller.signal.aborted || readStoredAuthToken() !== data.token) return;
  navigate(target, { replace: true, state: workspaceBootstrap ? { workspaceBootstrap } : null });
}
